module.exports = __webpack_public_path__ + "static/media/loc3_img16.71f342f4.jpg";